import * as API from 'common/constant/routes'
import { getJson } from 'helper/http'

export const getAllOrganisations = () => getJson(API.GET_ALL_ORGANISATIONS, {}, {})
